import LogRocket from 'logrocket';
import template from './shutoff.component.html';

/* @ngInject */
function shutoffPanelController(
  $scope,
  growl,
  ShutoffThresholdPanelService,
  DashboardService,
  ModalService
) {
  const vm = this;

  // public variables
  vm.loadingSpinners = {};
  vm.editPanel = {
    needsToBeConfigured: false
  };
  vm.equipments = ShutoffThresholdPanelService.shutoffThresholdModel;
  vm.headerModel = {};

  // public functions
  vm.setActiveEquipment = setActiveEquipment;
  vm.setNewThreshold = setNewThreshold;
  vm.updateCurrentReadingFromEvent = updateCurrentReadingFromEvent;
  vm.changeSchedule = changeSchedule;
  vm.deleteModel = deleteModel;


  vm.$onInit = () => {
    vm.currentDashboard = DashboardService.getCurrentDashboard();
    vm.panel = vm.currentDashboard.panels[vm.panelId];

    if (vm.panel.equipment && vm.panel.equipment.length) {
      vm.loadingSpinners.stopShutoffThresholdPanel = false;
      vm.editPanel.needsToBeConfigured = false;
      init(vm.panel.equipment);
      setupEventListeners(vm.panel.equipment);
    } else {
      vm.loadingSpinners.stopShutoffThresholdPanel = true;
      vm.editPanel.needsToBeConfigured = true;
    }
  };

  function init(equipmentIds) {
    ShutoffThresholdPanelService.getEquipmentFromIds(equipmentIds)
      .then((equipment) => {
        _.forEach(equipment, (eq) => {
          const { id } = eq;
          if (!vm.activeEquipmentId) {
            vm.activeEquipmentId = id;
          }
          vm.headerModel[id] = eq;
          ShutoffThresholdPanelService.getStatusForEquipment(id)
            .then(({ currentReading, enabled, timerSettings }) => {
              vm.equipments[id] = _.assign(vm.equipments[id], { currentReading, enabled, timerSettings });
            })
            .finally(() => {
              vm.loadingSpinners.stopShutoffThresholdPanel = true;
            });
        });
      });
  }

  function setActiveEquipment(equipment) {
    vm.activeEquipmentId = equipment.id;
  }

  function setNewThreshold() {
    vm.settingThreshold = true;
    let growlMessage = growl.info('Setting Threshold...', {
      disableCloseButton: true
    });
    ShutoffThresholdPanelService
      .setNewThreshold(vm.headerModel[vm.activeEquipmentId], vm.newWarningThreshold, vm.newShutoffThreshold)
      .then(() => {
        growlMessage.destroy();
        growlMessage = growl.success('Threshold saved successfully!');
        vm.newWarningThreshold = null;
        vm.newShutoffThreshold = null;
        vm.settingThreshold = false;
      })
      .catch((res) => {
        growlMessage.destroy();
        const error = 'Error Setting Threshold';
        growlMessage = growl.error(res.error, { title: error });
        LogRocket.track(error);
        vm.settingThreshold = false;
      });
  }

  function updateCurrentReadingFromEvent(eventObj) {
    ShutoffThresholdPanelService.updateCurrentReadingFromEvent(eventObj);
  }

  function changeSchedule() {
    const eqModel = vm.equipments[vm.activeEquipmentId];
    const eq = eqModel.equipment;
    const scheduleOptions = {
      title: 'Schedule Shutoff',
      eq,
      scheduleSettings: eqModel.schedule,
      scheduleEnabled: eqModel.enabled,
      canEnableSchedule: true
    };
    ModalService.openScheduler(scheduleOptions)
      .then(({ scheduleSettings, scheduleEnabled }) => {
        let growlMessage = growl.info('Saving schedule...', {
          disableCloseButton: true
        });
        ShutoffThresholdPanelService.setSchedule(eq.equipment, angular.copy(scheduleSettings))
          .then(() => {
            growlMessage.destroy();
            growlMessage = growl.success('Schedule saved successfully.');
            saveShutoffEnableDisable(scheduleEnabled);
          })
          .catch((res) => {
            growlMessage.destroy();
            growlMessage = growl.error(res.error, {
              title: 'Error saving schedule'
            });
          });
      });
  }

  function saveShutoffEnableDisable(isEnabled) {
    const action = isEnabled ? 'Enab' : 'Disab';

    let growlMessage = growl.info(`${action}ing Schedule...`, {
      disableCloseButton: true
    });

    ShutoffThresholdPanelService.toggleSchedule(vm.equipments[vm.activeEquipmentId].equipment, action)
      .then(() => {
        growlMessage.destroy();
        growlMessage = growl.success(`Schedule ${action}led!`);
      })
      .catch((res) => {
        growlMessage.destroy();
        growlMessage = growl.error(res.error, {
          title: `Error ${action}ling Schedule:`
        });
        LogRocket.track('Shuttoff update error');
      });
  }

  function deleteModel() {
    ShutoffThresholdPanelService.deleteModel();
  }

  function setupEventListeners(equipments) {
    _.forEach(equipments, (equipmentId) => {
      $scope.$on(`event:${equipmentId}`, (__, eventObj) => {
        vm.updateCurrentReadingFromEvent(eventObj);
      });
    });
  }

  $scope.$on('$destroy', () => {
    vm.deleteModel(vm.panel.equipment);
  });
}


export default {
  name: 'shutoffPanel',
  template,
  controller: shutoffPanelController,
  controllerAs: 'ShutoffThresholdCtrl',
  bindings: {
    panelId: '='
  }
};
